import React, { useCallback, useEffect } from 'react';
import { AppContent, Tabs } from '@common/components';
import { setBreadcrumbs } from 'works/legacy/lib/client-store';
import { useNavigate, useParams } from '@common/hooks';
import {
  BillingDisputeList,
  BillingPageStats,
  BillingReverseInvoiceList,
} from '@pay-bill/components';

export const BillingPage = () => {
  const navigate = useNavigate();
  const { tab } = useParams<{ tab: string }>();

  useEffect(() => {
    setBreadcrumbs([{ name: 'Billing', path: '/works/supplier/billing' }]);
  }, []);

  const handleTabChange = useCallback(
    (key: React.Key) => {
      navigate(`/works/supplier/billing/${key}`);
    },
    [navigate]
  );

  return (
    <AppContent>
      <BillingPageStats />
      <div className="tabs">
        <Tabs activeKey={tab} defaultActiveKey={tab} onChange={handleTabChange}>
          <Tabs.Pane tab="Reverse Invoices" key="reverseInvoices">
            <BillingReverseInvoiceList />
          </Tabs.Pane>
          <Tabs.Pane tab="Disputes" key="disputes">
            <BillingDisputeList selectable />
          </Tabs.Pane>
        </Tabs>
      </div>
      <style jsx>{`
        .tabs {
          margin-top: 24px;
        }
        .table-wrapper {
          padding-top: 3.5rem;
        }
        .center {
          display: flex;
          justify-content: center;
          width: 100%;
        }
      `}</style>
    </AppContent>
  );
};
